import React, { useEffect, useRef } from "react";
import "./ProductDetail128.css";

function ProductDetail128() {
  const row1 = useRef(null);
  const row2 = useRef(null);
  const row3 = useRef(null);
  const row4 = useRef(null);
  const row5 = useRef(null);
  const row6 = useRef(null);
  const row7 = useRef(null);
  const row8 = useRef(null);

  const allRows = [row1, row2, row3, row4, row5, row6, row7, row8];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.12 }
    );

    allRows.forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="core-features">
         <div className="cf-blue-shades" aria-hidden="true">
    <div className="cf-shade--1"></div>
    <div className="cf-shade--2"></div>
    <div className="cf-shade--3"></div>
    <div className="cf-shade--4"></div>
    <div className="cf-shade--5"></div>
    <div className="cf-shade--6"></div>
  </div>
      {/* ===== BACKGROUND EFFECTS ===== */}
      <div className="cf-bg-effects" aria-hidden="true">
        <div className="cf-glow cf-glow--1"></div>
        <div className="cf-glow cf-glow--2"></div>
        <div className="cf-glow cf-glow--3"></div>
        <div className="cf-glow cf-glow--4"></div>
        <div className="cf-glow cf-glow--5"></div>
      </div>

      <div className="tp-wrap">
        {/* ===== SECTION HEADER ===== */}
        <div className="cf-header">
          <span className="cf-eyebrow">CORE FEATURES</span>
          <h2 className="cf-h2">
            Next Gen <span>TPMS Experience</span>
          </h2>
          <p className="cf-subtitle">
            Powered by AI-driven intelligence for complete toll operations
            control
          </p>
        </div>

        {/* ===== FEATURE ROWS ===== */}
        <div className="cf-rows">
          {/* ── 01 ── AI-Based Real-Time Monitoring */}
          <div className="cf-row" ref={row1}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/feature-monitoring3.jpeg"
                  alt="AI-Based Real-Time Monitoring"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">LIVE MONITORING</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">01</span>
              <h3>AI-Based Real-Time Monitoring</h3>
              <p>
                TPMS continuously monitors all toll lanes using AI-powered
                cameras and sensors, providing instant alerts for congestion,
                inactive lanes, or suspicious activities.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 02 ── Vehicle & Axle Detection */}
          <div className="cf-row cf-row--reverse" ref={row2}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/feature-detection-LR.jpeg"
                  alt="Vehicle and Axle Detection"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">OCR + AI</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">02</span>
              <h3>Vehicle &amp; Axle Detection</h3>
              <p>
                Using OCR and AI vision, TPMS automatically identifies vehicle
                types and axle counts with up to 97% accuracy, ensuring correct
                toll calculation every time.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 03 ── FASTag Verification System */}
          <div className="cf-row" ref={row3}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/feature-fastag-LR.jpeg"
                  alt="FASTag Verification System"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">FASTAG VERIFY</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">03</span>
              <h3>FASTag Verification System</h3>
              <p>
                TPMS validates every FASTag transaction by matching vehicle data
                with transaction records, ensuring transparency and eliminating
                mismatches.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 04 ── Fraud Detection & Exemption Control */}
          <div className="cf-row cf-row--reverse" ref={row4}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/feature-fraud-LR.jpeg"
                  alt="Fraud Detection and Exemption Control"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">FRAUD PREVENT</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">04</span>
              <h3>Fraud Detection &amp; Exemption Control</h3>
              <p>
                Unauthorized exemptions are instantly flagged by verifying
                vehicles against approved databases, preventing misuse and
                revenue loss in real-time.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 05 ── Centralized Dashboard & Analytics */}
          <div className="cf-row" ref={row5}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/dashboard-LR-1.jpeg"
                  alt="Centralized Dashboard and Analytics"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">ANALYTICS</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">05</span>
              <h3>Centralized Dashboard &amp; Analytics</h3>
              <p>
                Monitor multiple toll plazas from a single dashboard with
                real-time insights on traffic, revenue, and performance metrics
                at your fingertips.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 06 ── Audit-Ready Reports */}
          <div className="cf-row cf-row--reverse" ref={row6}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/reports-LR.jpeg"
                  alt="Audit-Ready Reports"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">REPORTS</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">06</span>
              <h3>Audit-Ready Reports</h3>
              <p>
                Generate detailed reports including vehicle images, timestamps,
                and logs — ensuring complete compliance and hassle-free audit
                processes.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 07 ── Role-Based Secure Access */}
          <div className="cf-row" ref={row7}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/Hero-Image-LR.png"
                  alt="Role-Based Secure Access"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">SECURITY</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">07</span>
              <h3>Role-Based Secure Access</h3>
              <p>
                Control system access with role-based permissions for operators,
                managers, and admins — ensuring data security and operational
                integrity at every level.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          {/* ── 08 ── Cloud-Based Multi-Plaza System */}
          <div className="cf-row cf-row--reverse" ref={row8}>
            <div className="cf-img-wrap">
              <svg
                className="cf-border-svg"
                viewBox="0 0 100 100"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path
                  className="cf-border-path"
                  d="M 1 99 L 97 99 Q 99 99 99 97 L 99 1"
                  vector-effect="non-scaling-stroke"
                />
              </svg>
              <div className="cf-img">
                <img
                  src="ImagesNew/feature-fastag-LR.jpeg"
                  alt="Cloud-Based Multi-Plaza System"
                  loading="lazy"
                />
                <div className="cf-img-overlay"></div>
                <span className="cf-tag">CLOUD</span>
              </div>
            </div>
            <div className="cf-content">
              <span className="cf-num">08</span>
              <h3>Cloud-Based Multi-Plaza System</h3>
              <p>
                Manage multiple toll locations from a single cloud platform with
                high scalability, reliability, and seamless integration
                capabilities across your entire network.
              </p>
              <button className="cf-btn">
                Explore More <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductDetail128;